import { identityColour } from "./identityColour";

/**
 * UI-8 — how a person is drawn wherever they appear.
 *
 * Initials on a brand colour, never a photo: the handoff is explicit that there is no
 * upload, and nothing in the schema stores one. The colour is derived from the person's
 * id rather than assigned as they are rendered, for the reason `identityColour` gives —
 * the point of a colour is recognition, so the same person has to be the same colour on
 * the gallery card, on their dossier, and on whatever screen shows them next.
 *
 * The ramp holds ten and then wraps, the same ten a speaker draws from.
 */
export function personColour(id: string): string {
  // A sum of code points, not a real hash: it only has to be stable and spread, and a
  // person's id is a uuid whose characters are already well distributed. Measured over
  // 200k uuids it fills ten buckets as evenly as it filled five.
  let total = 0;
  for (let index = 0; index < id.length; index += 1) total += id.charCodeAt(index);

  return identityColour(total);
}

/** The two letters on the avatar: first and last name, or the first two characters of a
 * single-word name. */
export function personInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";

  const letters = parts.length === 1 ? parts[0]!.slice(0, 2) : `${parts[0]![0]}${parts[parts.length - 1]![0]}`;

  return letters.toUpperCase();
}
